var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{class:_vm.$classes(),style:(_vm.genericStyles()),attrs:{"data":_vm.series,"library":_vm.options}})}
var staticRenderFns = []

export { render, staticRenderFns }